import React from "react";
import "./../style/common.css"

const PrivacyPolicy = () => {
  return (
    <div className="page-container">
      <h1>Privacy Policy</h1>
      <p>
        Mandurah Cafe is committed to protecting your privacy. This policy explains how we collect, use, and safeguard your information when you use our website and services.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        We may collect personal details such as your name, email, phone number, delivery address, and payment information when you place an order or create an account.
      </p>

      <h2>2. How We Use Your Information</h2>
      <p>
        Your information is used to process orders, provide customer service, send updates, and improve our services. We do not sell or rent your personal data to third parties.
      </p>

      <h2>3. Payment Security</h2>
      <p>
        All payment transactions are processed through secure payment gateways. We do not store your credit card information on our servers.
      </p>

      <h2>4. Cookies</h2>
      <p>
        Our website may use cookies to enhance user experience. You can choose to disable cookies via your browser settings.
      </p>

      <h2>5. Third-Party Services</h2>
      <p>
        We may use third-party services for delivery, analytics, or marketing. These services are bound by their own privacy policies.
      </p>

      <h2>6. Data Retention</h2>
      <p>
        We retain your data for as long as necessary to provide our services or as required by law.
      </p>

      <h2>7. Your Rights</h2>
      <p>
        You have the right to access, update, or request deletion of your personal information. For requests, please contact us at <a href="mailto:support@mandurahcafe.com.au">support@mandurahcafe.com.au</a>.
      </p>

      <h2>8. Changes to this Policy</h2>
      <p>
        We may update this Privacy Policy periodically. Continued use of the site indicates your acceptance of any changes.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
